/** @format */

import VoucherActionTypes from './voucher.types';

export const setVoucherDate = (date) => ({
  type: VoucherActionTypes.SET_VOUCHER_DATE,
  payload: date,
});

export const fetchVoucherInvSegKeyStart = () => ({
  type: VoucherActionTypes.FETCH_VOUCHER_INV_SEG_KEY_START,
});

export const fetchVoucherInvSegKeySuccess = (invSegKeys) => ({
  type: VoucherActionTypes.FETCH_VOUCHER_INV_SEG_KEY_SUCCESS,
  payload: invSegKeys,
});

export const fetchVoucherInvSegKeyFailure = (error) => ({
  type: VoucherActionTypes.FETCH_VOUCHER_INV_SEG_KEY_FAILURE,
  payload: error,
});

export const fetchVoucherBatchCustomersStart = () => ({
  type: VoucherActionTypes.FETCH_VOUCHER_BATCH_CUSTOMERS_START,
});

export const fetchVoucherBatchCustomersSuccess = (batchCustomers) => ({
  type: VoucherActionTypes.FETCH_VOUCHER_BATCH_CUSTOMERS_SUCCESS,
  payload: batchCustomers,
});

export const fetchVoucherBatchCustomersFailure = (error) => ({
  type: VoucherActionTypes.FETCH_VOUCHER_BATCH_CUSTOMERS_FAILURE,
  payload: error,
});

export const sendVoucherEmailStart = () => ({
  type: VoucherActionTypes.SEND_VOUCHER_EMAIL_START,
});

export const sendVoucherEmailSuccess = (emailStatus) => ({
  type: VoucherActionTypes.SEND_VOUCHER_EMAIL_SUCCESS,
  payload: emailStatus,
});

export const sendVoucherEmailFailure = (error) => ({
  type: VoucherActionTypes.SEND_VOUCHER_EMAIL_FAILURE,
  payload: error,
});

export const setVoucherSelectedKeys = (keys) => ({
  type: VoucherActionTypes.SET_VOUCHER_SELECTED_KEYS,
  payload: keys,
});

export const setVoucherSelectedCustomers = (customers) => ({
  type: VoucherActionTypes.SET_VOUCHER_SELECTED_CUSTOMERS,
  payload: customers,
});
